import { forEach } from 'lodash';

import { cloneDeep } from 'gear';

import { Xml } from '../util';

import { Point, Matrix, Bounds, Frame, Cubic, Boundary, Curve } from '../geometry';
import { Color, Pen } from '../style';
import { Shape, Polyregion } from '../figure';


export const Envelope = function(curves) {
  this.curves = curves ;
};

Envelope.prototype = {
  d() { return this.curves[0]; },
  r() { return this.curves[1]; },
  u() { return this.curves[2]; },
  l() { return this.curves[3]; },
  getFirstPoint() {
    return this.curves[0].getFirstPoint().clone();
  },
  buildXml ( parentNode ) { Xml.addObject(parentNode,this,'Envelope'); },
  setupXml( node ) {
    const { curves } = this;
    const { appendElement } = Xml;
    //_.forEach(curves,function(c) {
    for(let k=0,kEnd=curves.length;k<kEnd;++k) {
      curves[k].setupXml(appendElement(node,'Curve'));
    }//);
  },
  transform( t ) {
    forEach( this.curves, curve => {
      curve.transform(t);
    });
    return this;
  },
  vectorBounds() {
    return Bounds.ofThings(this.curves);
  },

  get bounds() {
    return Bounds.ofThings(this.curves);
  },
  get center() {
    return this.bounds.center;
  },

  setSize( options ) {
    // [TODO] Add more functionality options.locked, options.width, etc... abstract from Figures.setSize$
    const bounds = this.vectorBounds();
    const scale = options.height ? options.height / bounds.height : 1.0;
    this.transform( Matrix.scaleFrom(bounds.center,scale,scale) );
  },
  isEqual( other ) {
    // Envelopes that are offseted with respect to each other are considered equal
    const  this_offset = Matrix.translate( Point.minus(  this.vectorBounds().center ) );
    const other_offset = Matrix.translate( Point.minus( other.vectorBounds().center ) );
    const this_curves = this.curves, other_curves = other.curves;
    return this_curves[0].transformed(this_offset).isEqual(other_curves[0].transformed(other_offset)) &&
           this_curves[1].transformed(this_offset).isEqual(other_curves[1].transformed(other_offset)) &&
           this_curves[2].transformed(this_offset).isEqual(other_curves[2].transformed(other_offset)) &&
           this_curves[3].transformed(this_offset).isEqual(other_curves[3].transformed(other_offset));
  },
  asBoundary() {
    let pieces = [];
    forEach( this.curves, c => {
      pieces = pieces.concat(cloneDeep(c.pieces));
    });
    return Curve.fromNonTiedPieces(pieces,true);
  },
  asShape( config = {} ) {
    const boundary = this.asBoundary();
    if( ! config.pen ) {
      config.pen = new Pen({width:1,color:Color.Black()});
    }
    const polyregion = Polyregion.createFromBoundary(boundary,config);
    return Shape.createFromPolyregion(polyregion);
  },
  clone() {
    return new Envelope(cloneDeep(this.curves));
  }
};

Envelope.fromXml = function (parentNode ) { return Xml.getObject(parentNode,this,'Envelope'); };
Envelope.parseXml = function ( node ) {
  const curves = Boundary.arrayFromXml(node,'Curve');
  return new Envelope(curves);
};

Envelope.createFromFrame = function( frame ) {
  const { p0, p1, p2, p3 } = frame.clone();
  const cubicFromSegment = Cubic.fromSegment, interpolate = Point.interpolate;
  const pm01 = interpolate(p0,p1,0.5),
      pm12 = interpolate(p1,p2,0.5),
      pm23 = interpolate(p2,p3,0.5),
      pm30 = interpolate(p3,p0,0.5);
  const curves = [ new Curve( [cubicFromSegment(p0,pm01),cubicFromSegment(pm01,p1.clone())], false ),
                 new Curve( [cubicFromSegment(p1,pm12),cubicFromSegment(pm12,p2.clone())], false ),
                 new Curve( [cubicFromSegment(p2,pm23),cubicFromSegment(pm23,p3.clone())], false ),
                 new Curve( [cubicFromSegment(p3,pm30),cubicFromSegment(pm30,p0.clone())], false ) ];
  return new Envelope(curves) ;
};

Envelope.createFromBounds = function(bounds) {
  const frame = Frame.fromBounds(bounds);
  return Envelope.createFromFrame(frame);
};

Envelope.createFromFigure = function( figure ) { // [TODO] _ or $
  return Envelope.createFromBounds(figure.preVectorBounds_());
};



/** WEBPACK FOOTER **
 ** ./src/cdl/process/envelope.js
 **/